import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usePortalAuth } from '@/contexts/PortalAuthContext';
import { portalApi } from '@/lib/api';
import { FileText, ClipboardList, ChevronRight, CheckCircle2 } from 'lucide-react';

export default function PortalHome() {
  const { staff } = usePortalAuth();
  const [pending, setPending] = useState(null);
  const [docs, setDocs] = useState(null);

  useEffect(() => {
    portalApi.get('/staff/me/tasks').then(({ data }) => setPending(data.tasks.filter((t) => t.status !== 'COMPLETED').length));
    portalApi.get('/staff/me/documents').then(({ data }) => setDocs(data.documents.length));
  }, []);

  return (
    <div className="space-y-5" data-testid="portal-home">
      <div>
        <h1 className="font-heading text-2xl font-700 text-charcoal">Hi {staff?.name?.split(' ')[0]} 👋</h1>
        <p className="text-sm text-muted-ink">Here&apos;s your workspace at THE TIFFIN.</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Link to="/portal/tasks" data-testid="portal-home-tasks-card" className="bg-white rounded-2xl border border-border/40 p-4 hover:border-saffron/50 transition-colors duration-150">
          <ClipboardList size={20} className="text-saffron" />
          <p className="font-heading text-3xl font-700 text-charcoal mt-2">{pending ?? '—'}</p>
          <p className="text-xs text-muted-ink">Pending activities</p>
        </Link>
        <Link to="/portal/documents" data-testid="portal-home-docs-card" className="bg-white rounded-2xl border border-border/40 p-4 hover:border-saffron/50 transition-colors duration-150">
          <FileText size={20} className="text-coriander" />
          <p className="font-heading text-3xl font-700 text-charcoal mt-2">{docs ?? '—'}</p>
          <p className="text-xs text-muted-ink">My documents</p>
        </Link>
      </div>

      {pending === 0 && (
        <div className="bg-coriander/10 text-coriander rounded-xl p-3 text-sm flex items-center gap-2" data-testid="portal-all-done">
          <CheckCircle2 size={16} /> You&apos;re all caught up — no pending activities.
        </div>
      )}

      <div className="bg-white rounded-2xl border border-border/40 divide-y divide-border/30">
        <Link to="/portal/tasks" className="flex items-center justify-between p-4 hover:bg-bone/50">
          <span className="text-sm text-charcoal">View my activities &amp; requirements</span>
          <ChevronRight size={16} className="text-muted-ink" />
        </Link>
        <Link to="/portal/documents" className="flex items-center justify-between p-4 hover:bg-bone/50">
          <span className="text-sm text-charcoal">Upload &amp; view my documents</span>
          <ChevronRight size={16} className="text-muted-ink" />
        </Link>
        <Link to="/portal/profile" className="flex items-center justify-between p-4 hover:bg-bone/50">
          <span className="text-sm text-charcoal">My profile &amp; contact info</span>
          <ChevronRight size={16} className="text-muted-ink" />
        </Link>
      </div>
    </div>
  );
}
